import { Node } from "../../src/shell/Actions/Action";
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { doDoorKnock, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V6EmilyJoeOutsideAfter } from "./V6";
const v6 = images.v6;
export const V6EmilyJoeOutside = async (): Promise<any> => {
    empty.think(`*Noises*`);
    mc.think(`What's that?`);
    mc.think(`It's probably just Emily, but I better go check just to be safe.`);
    doTransition(v6.EmilyJoeOutside_4);
    mc.think(`What the fuck is this?`);
    mc.think(`Emily and Joey?! What the fuck?`);
    mc.think(`Don't tell me they are dating. No way!`);
    if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor) {
        mc.think(`Not only did he get a blowjob from Ann, but now he's hanging out with Emily?`);
    } else {
        mc.think(`Not only did he try to get Ann to suck his dick, but now he's hanging out with Emily?`);
    }
    mc.think(`He's doing all he can just to get back at me!`);
    mc.think(`What the fuck is she doing with him anyway?`);
    ImageClass.setImage(images.v6.EmilyJoeOutside_2);
    mc.think(`And she's wearing the dress I picked out for her no less.`);
    ImageClass.setImage(images.v6.EmilyJoeOutside_2.partials.EmilyJoeOutside_2_p);
    mc.think(`She is way overdressed...`);
    mc.think(`And Joey? He couldn't even bother to put on nicer shoes.`);
    ImageClass.setImage(images.v6.EmilyJoeOutside_2);
    mc.think(`Oh, shit. I think she's coming back!`);

    return jump(V6_EmilyAfterJoeRivalConv_Room, "V6_EmilyAfterJoeRivalConv_Room");
};

export const V6_EmilyAfterJoeRivalConv_Room = async (): Promise<any> => {
    doTransition(v6.EmilyAfterJoeRivalConv_0);
    doDoorKnock();
    // emily.talk(`Come in!`, { method: "Shouting" });
    doWaitImageByTime(v6.EmilyAfterJoeRivalConv_1);
    mc.talk(`Hey Emily, do you have a minute?`);
    doWaitImageByTime(v6.EmilyAfterJoeRivalConv_2);
    emily.talk(`Of course! What's on your mind?`);
    mc.talk(`Where have you been?`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_3);
    emily.talk(`Around...`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_4);

    emily.talk(`Well... I guess there is no point denying it.`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_3);
    emily.talk(`I was with... Joey.`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_6);
    emily.talk(`Before you say anything!`);
    emily.talk(`Nothing happened!`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_7);
    emily.talk(`I was just bored and he texted me and asked if I'm available to talk.`);
    emily.talk(`He's having troubles with his girlfriend, Vanessa.`);
    emily.talk(`He wanted my advice...`);
    emily.talk(`He would have talked to you but he also said you aren't on best terms right now...`);

    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_15);
    emily.talk(`I was so bored and I was looking for an excuse to try on this dress, so I said... Fuck it, why not?`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_7);
    emily.talk(`I know I should have told you beforehand... But as I said, nothing happened, we were just talking and eating dinner. That's it.`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_8);
    emily.talk(`...`);
    doWaitImageByTime(images.v6.EmilyAfterJoeRivalConv_9);
    emily.talk(`You can respond now.`);
    mc.talk(`Sec, I need to think.`);

    doWaitImageByTime(images.v6.EmilyAfterJoeRivalConv_10);
    mc.think(`I'm glad to know nothing happened!`);
    mc.think(`Only a fool would think he didn't do this to get back at me.`);
    mc.think(`But what if he's really interested in her?`);
    mc.think(`Joey is a good guy... and it's me that betrayed him first...`);
    mc.think(`And Emily seemed happy, so maybe I'm just fooling myself?`);
    mc.think(`Nah! No way! He just wants to fuck with me at Emily's expense!`);
    doWaitImageByTime(images.v6.EmilyAfterJoeRivalConv_13);
    await mc.setQuestion(new Question({ text: `I think you should...`, options: { think: false }, key: `v6EmilyAfterJoeRivalConvAllowDatingJoe` })
        .option({ title: `Keep dating Joey`, key: true })
        .option({ title: `Stop seeing him`, key: false }));


    if (Question.globalAnswers.v6EmilyAfterJoeRivalConvAllowDatingJoe) {
        return jump(V6_EmilyAfterJoeRivalConv_Room_KeepDating, "V6_EmilyAfterJoeRivalConv_Room_KeepDating");
    }

    return jump(V6_EmilyAfterJoeRivalConv_Room_StopSeeing, "V6_EmilyAfterJoeRivalConv_Room_StopSeeing");

};

export const V6_EmilyAfterJoeRivalConv_Room_KeepDating = async (): Promise<any> => {
    mc.talk(`Keep dating Joey.`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_12);
    emily.talk(`Really?`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_13);
    mc.talk(`Sure, why not?`);
    emily.talk(`Because he is your friend? And he is younger than me?`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_16);
    emily.talk(`Hmm...`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_15);
    emily.talk(`But I guess I can give it a shot...`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_14);
    mc.talk(`It's up to you, I won't get in your way.`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_15);
    emily.talk(`I'll have to think about that. But thank you for being okay with that!`);
    doWaitImageByTime(images.v6.EmilyAfterJoeRivalConv_18);
    mc.talk(`Of course!`);

    return jump(V6_EmilyAfterJoeRivalConv_Room_2, "V6_EmilyAfterJoeRivalConv_Room_2");
};

export const V6_EmilyAfterJoeRivalConv_Room_StopSeeing = async (): Promise<any> => {
    mc.talk(`Stop seeing him.`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_17);
    emily.talk(`Yeah... It was stupid to meet with him in the first place.`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_12);
    emily.talk(`I guess I was just in a vulnerable place and he sent me a message at the right time`);
    emily.talk(`I'll tell him that it was just a one time thing and end it.`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_13);
    mc.talk(`That's the right thing to do.`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_17);
    emily.talk(`Thank you for not getting angry with me in the first place.`);
    mc.talk(`Hell no, I understand. And besides, you didn't do anything besides talking right?`);
    ImageClass.setImage(images.v6.EmilyAfterJoeRivalConv_12);
    emily.talk(`I swear we only talked.`);
    doWaitImageByTime(images.v6.EmilyAfterJoeRivalConv_18);
    mc.talk(`I believe you.`);
    return jump(V6_EmilyAfterJoeRivalConv_Room_2, "V6_EmilyAfterJoeRivalConv_Room_2");

};
export const V6_EmilyAfterJoeRivalConv_Room_2 = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8EmilyAndExRoom_18);
    await emily.setQuestion(new Question({ text: `She is getting ready for bed...`, options: { think: true }, key: `v6EmilyAfterJoeRivalConvPeepOnEmily` })
        .option({ title: `Peep on her`, key: true })
        .option({ title: `Give her privacy`, key: false }));


    if (Question.globalAnswers.v6EmilyAfterJoeRivalConvPeepOnEmily) {
        mc.think(`I can't help myself...`);
        doWaitImageByTime(images.v6.EmilyAfterJoeRivalConv_20);
        if (mc.properties.v6EmilyShoppingDress === "black") {
            mc.think(`Her breasts were dying to to pop out of that dress anyway`);
        } else {
            mc.think(`Such a hot body.`);
        }
    }
    if (Question.globalAnswers.v6EmilyAfterJoeRivalConvAllowDatingJoe) {
        mc.think(`Joey is so lucky...`);
    } else {
        mc.think(`No way I'll let Joey have a piece of that!`);
    }
    doWaitImageByTime(images.v6.EmilyAfterJoeRivalConv_21);
    mc.think(`Damn and she is even wearing a thong...`);
    mc.think(`I better leave before I get caught.`);

    return jump(V6_EmilyAfterJoeRivalConv_End, "V6_EmilyAfterJoeRivalConv_End");
};
export const V6_EmilyAfterJoeRivalConv_End = async (): Promise<any> => {

    return jump(V6EmilyJoeOutsideAfter, "V6EmilyJoeOutsideAfter");
};